const webVersion = process.env.VUE_APP_VERSION;
let baseUrl: any = "https://cg.testappbeta.com";
// let baseUrl: any = "https://api.soupep.com";
let PIN_AD_BASE_URL: any = "https://ad.testappbeta.com"; //pinad的请求url
let UMENG_BASE_URL: any = "https://umeng.testappbeta.com"; //打点的请求url

if (process.env.NODE_ENV === "development") {
} else if (process.env.NODE_ENV === "production") {
  //正式环境下才转正式服：
  //staging模式下还是指向测试服
  baseUrl = process.env.VUE_APP_GX_BASE_URL;
  PIN_AD_BASE_URL = process.env.VUE_APP_GX_PIN_AD_BASE_URL;
  UMENG_BASE_URL = process.env.VUE_APP_GX_UMENG_BASE_URL;
}

//==================== lazy load component to router ================
export const lazyConfig: any = [
  {
    route_name: "Followers",
    prerender_pic: require("@/assets/skeleton/sku.png")
  },
  {
    route_name: "Posts",
    prerender_pic: require("@/assets/skeleton/sku.png")
  },
  {
    route_name: "Stories",
    prerender_pic: require("@/assets/skeleton/sku.png")
  },
  {
    route_name: "SubsFollower",
    prerender_pic: require("@/assets/skeleton/subs.png")
  },
  {
    route_name: "SubsLike",
    prerender_pic: require("@/assets/skeleton/subs.png")
  },
  {
    route_name: "VipCenter",
    prerender_pic: require("@/assets/skeleton/vip.png")
  },
  {
    route_name: "DoubleCoinSplash",
    prerender_pic: require("@/assets/skeleton/doublecoins.png")
  }
];

export const CDN_BASE_URL: any = {
  img: "https://cdn.soupep.com/img",
  js: "https://cdn.soupep.com/js",
  css: "https://cdn.soupep.com/css",
  video: "https://cdn.soupep.com/video"
};

export { baseUrl, webVersion, PIN_AD_BASE_URL, UMENG_BASE_URL };
